import type { CompanySize, CompanyStatus } from '../types/company.types';

export const sizeLabels: Record<CompanySize, string> = {
  SMALL: '1-50',
  MEDIUM: '51-200',
  LARGE: '201-1000',
  ENTERPRISE: '1000+',
};

export const statusConfig: Record<
  CompanyStatus,
  { variant: 'default' | 'destructive' | 'secondary'; label: string }
> = {
  ACTIVE: { variant: 'default', label: 'Active' },
  SUSPENDED: { variant: 'destructive', label: 'Suspended' },
  DELETED: { variant: 'secondary', label: 'Deleted' },
};
